import React from "react";
import { LayoutTemplate } from "lucide-react";
import StakeholderPicker from "../StakeholderPicker";
import { inputCls } from "./QuickList";

const UNITS = ["Minutes", "Hours", "Days", "Weeks"];

function L({ label, children, className = "" }) {
  return (
    <div className={className}>
      <label className="text-[10px] uppercase tracking-widest text-slate-400">{label}</label>
      {children}
    </div>
  );
}

export default function DetailsStep({ form, setForm, templates, templateId, onPickTemplate, programs, stakeholders, teammates }) {
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <div data-testid="wizard-step-details" className="space-y-3">
      {templates.length > 0 && (
        <L label="Start from">
          <div className="flex items-center gap-2">
            <LayoutTemplate size={16} className="text-blue-400 shrink-0" />
            <select className={inputCls} value={templateId} onChange={(e) => onPickTemplate(e.target.value)} data-testid="wizard-template-select">
              <option value="">Blank project</option>
              {templates.map((t) => <option key={t.id} value={t.id}>{`${t.name} (${(t.source_tasks || []).length} tasks)`}</option>)}
            </select>
          </div>
          {templateId && <p className="text-xs text-blue-300/80 mt-1" data-testid="wizard-template-hint">Template loaded. Rename the project and adjust the details below before creating it.</p>}
        </L>
      )}
      <L label="Project name *">
        <input autoFocus required className={inputCls} value={form.name} onChange={set("name")} placeholder="e.g. Website Relaunch" data-testid="wizard-project-name" />
      </L>
      <L label="Description">
        <textarea rows={2} className={inputCls} value={form.description} onChange={set("description")} data-testid="wizard-project-description" />
      </L>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <L label="Program">
          <select className={inputCls} value={form.program_id} onChange={set("program_id")} data-testid="wizard-project-program">
            <option value="">None</option>
            {programs.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </L>
        <L label="Project owner">
          <select className={inputCls} value={form.project_owner_teammate_id} onChange={set("project_owner_teammate_id")} data-testid="wizard-project-owner">
            <option value="">Unassigned</option>
            {teammates.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
        </L>
        <L label="Project manager">
          <select className={inputCls} value={form.pm_teammate_id} onChange={set("pm_teammate_id")} data-testid="wizard-project-pm">
            <option value="">Unassigned</option>
            {teammates.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
        </L>
        <L label="Due date"><input type="date" className={inputCls} value={form.stated_due_date} onChange={set("stated_due_date")} data-testid="wizard-project-due" /></L>
        <L label="Budget"><input type="number" min={0} className={inputCls} value={form.stated_budget} onChange={set("stated_budget")} data-testid="wizard-project-budget" /></L>
        <L label="Time unit">
          <select className={inputCls} value={form.time_unit} onChange={set("time_unit")} data-testid="wizard-project-unit">
            {UNITS.map((u) => <option key={u} value={u}>{u}</option>)}
          </select>
        </L>
      </div>
      <L label="Stakeholders on this project">
        <div className="mt-1"><StakeholderPicker stakeholders={stakeholders} selected={form.stakeholder_ids} onChange={(ids) => setForm({ ...form, stakeholder_ids: ids })} testId="wizard-stakeholder-picker" /></div>
      </L>
    </div>
  );
}
